import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { ContentProvider } from './ContentProvider';
import { DatesProvider } from './DatesProvider';
import { Loading } from '@/components/partials/loading/Loading';
import { Notifications } from '@mantine/notifications';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<MantineProvider>
					<Notifications autoClose={5000} />
					<QueryProvider>
						<AuthProvider>
							<ContentProvider>
								<DatesProvider>
									<Suspense fallback={<Loading fullHeight />}>
										{children}
									</Suspense>
								</DatesProvider>
							</ContentProvider>
						</AuthProvider>
					</QueryProvider>
				</MantineProvider>
			</BrowserRouter>
		</Provider>
	);
};
